import { AppThunkAction } from "..";
import { BusinessCreditReportTypes, RECEIVE_BUSINESS_CREDIT_REPORT, REQUEST_BUSINESS_CREDIT_REPORT, IBusinessCreditReportResponse, IUiData } from "./types";
import * as services from "../service";

export const actionCreators = {
    requestBusinessCreditReport:
        (reportPK: string, forceFullyRefresh: boolean, creditProvider: string): AppThunkAction<BusinessCreditReportTypes> =>
        (dispatch, getState) => {
            const appState = getState();

            let needToRefresh = false;
            if (appState?.businessCreditReportState?.creditReportData?.find((it: IBusinessCreditReportResponse) => it.reportPK)) {
                needToRefresh = !reportPK && !forceFullyRefresh;
            }

            if (
                appState != null &&
                appState.businessCreditReportState != null &&
                ((!appState.businessCreditReportState.creditReportData && appState.businessCreditReportState.isLoading === false) ||
                    forceFullyRefresh === true ||
                    needToRefresh === true)
            ) {
                services
                    .getBusinessCreditReport(reportPK, creditProvider)
                    .then((data) => {
                        let temData = data;
                        // remove PII from redux store
                        delete temData[0].businessCompanyReport;
                        services.getAllBusinessCreditHistory().then((historyData) => {
                            let creditReportData: IBusinessCreditReportResponse[] = temData;

                            if (historyData) {
                                let uiData: IUiData = {};

                                //Bug: 27035-Getting two credit reports for a  newly added business
                                //Below Filter applied for solving issue when new business user account created, after that it's created two same credit report
                                //So resolve this issue by removing one from response,
                                //Note: it's happen only D&B user.
                                if (creditProvider === "DUNBRADSTREET") {
                                    historyData = historyData.filter(
                                        (thing: any, index: any, self: any) =>
                                            index ===
                                            self.findIndex(
                                                (t: any) =>
                                                    t.alertDate === thing.alertDate &&
                                                    t.createdTime === thing.createdTime &&
                                                    t.alertTitle === thing.alertTitle &&
                                                    t.alertCategory === thing.alertCategory
                                            )
                                    );
                                }

                                if (reportPK) {
                                    const currentCreditReportIndex: any = historyData.findIndex((it: any) => it.alertID === reportPK);
                                    if (currentCreditReportIndex !== -1) {
                                        if (historyData.length > currentCreditReportIndex) {
                                            uiData.currentDate = historyData[currentCreditReportIndex].alertDate;
                                        }
                                        if (historyData.length > currentCreditReportIndex + 1) {
                                            uiData.previousDate = historyData[currentCreditReportIndex + 1].alertDate;
                                        }
                                    }
                                } else {
                                    if (historyData.length > 0) {
                                        uiData.currentDate = historyData[0].alertDate;
                                    }
                                    if (historyData.length > 1) {
                                        uiData.previousDate = historyData[1].alertDate;
                                    }
                                }

                                creditReportData.forEach((creditReport) => {
                                    creditReport.uiData = uiData;
                                    creditReport.historyLength = historyData.length;
                                    creditReport.reportPK = reportPK;
                                });
                            }

                            dispatch({
                                type: RECEIVE_BUSINESS_CREDIT_REPORT,
                                creditReportData: creditReportData && creditReportData.length > 0 ? creditReportData : undefined,
                            });
                        });
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_BUSINESS_CREDIT_REPORT, creditReportData: undefined });
                    });
                dispatch({ type: REQUEST_BUSINESS_CREDIT_REPORT });
            }
        },
};
